<template>
    <div class="home-all">
        <ul class="banner">
            <li :style="'background:url('+$parent.baseUrl+'/static/images/banner.jpg) no-repeat top center;'">
                <router-link class="link db" v-if="$parent.trialInfoType === 2" :to="{path:''+$parent.baseUrl+'/yuYingGather'}">
                    <button class="btn btn-jbblue">立即使用</button>
                </router-link>
                <a class="link db" v-if="$parent.trialInfoType != 2" href="https://u1.nybkz.com/member/register">
                    <button class="btn btn-jbblue">免费试用</button>
                </a>
            </li>
        </ul>
		<!-- 漂浮活动入口 -->
		<a class="activity-ad" v-if="activity != ''" :href="activity.activityUrl" target="_blank"><img :src="activity.logo" /></a>
        <div class="container" style="margin-top:-260px;">
            <div class="index-box clearfix">
                <div class="index-title ac">
                    <h1><span class="color-white">热点事件追踪</span></h1>
                    <p>助你第一时间掌握最新热点事件</p>
                </div>
                <div class="mt50">
                    <div class="home-news fl">
                        <div class="tab-warp">
                            <ul class="tab clearfix" :class="move">
                                <li v-for="(item,index) in indexEventType" :class="currHotType === index ? 'curr' : ''" @click="clickHotEvent(index);" :key="index">{{item.name}}</li>
                            </ul>
                            <a class="more" href="javascript:void(0);" :class="move === 'down' ? 'back' : ''" v-if="indexEventType.length > 11" @click="clickMore();">{{move === 'down' ? '返回' : '更多'}}</a>
                        </div>
                        <div class="home-news-body mt15">
                            <!-- <ul class="news-img clearfix">
                                <li v-for="(item,index) in indexEventList[0]" :key="index">
                                    <router-link target="_blank" :to="{path:''+$parent.baseUrl+'/eventDetail',query: {id:item.id}}">
                                        <img :src="item.icon != '' ? item.icon :''+$parent.baseUrl+'/static/images/default.png'" class="img db"/>
                                        <span class="name ovhidden ac">{{item.name}}</span>
                                    </router-link>
                                </li>
                            </ul> -->
                            <div class="mt20 clearfix">
                                <ul class="index-news fl">
                                    <li class="ovhidden" v-for="(item,index) in indexEventList[0]" :key="index"><span class="bull">&bull;</span><a class="color-3d3d4c" target="_blank" :href="item.url">{{item.name}}</a></li>
                                </ul>
                                <ul class="index-news fr">
                                    <li class="ovhidden" v-for="(item,index) in indexEventList[1]" :key="index"><span class="bull">&bull;</span><a class="color-3d3d4c" target="_blank" :href="item.url">{{item.name}}</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 近24小时热点事件榜单 -->
                <div class="hot-news fr">
                    <h2 class="clearfix">
                        <span class="fl">
                            <i class="icons hot-icon"></i>近7天热点事件榜单
                        </span>
                        <div class="grid-info fl">
                            <i class="icons icons-question-circle"></i>
                            <p class="grid-tip">热度值：根据转载传播量计算事件热度值</p>
                        </div>
                    </h2>
                    <ul class="index-news mt10">
                        <li v-for="(item,index) in hotOneDayNewsList" :key="index">
							<a class="link ovhidden fl" :href="item.url" target="_blank"><i class="number fl">{{index+1}}</i>{{item.name}}</a>
                            <!-- <i class="icons fr mt10" :class="[{'icon-up':item.up>0},{'icon-down':item.up<0},{'icon-middle':item.up==0}]"></i> -->
                            <strong class="color-red fr">{{item.count}}</strong>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="index-box clearfix">
                <div class="index-title ac">
                    <h1>舆论大数据分析平台</h1>
                    <p>基于数据化的舆论分析，智能跟踪传播路径，助力解决舆论领域传播分析,评估与决策难题</p>
                </div>
                <div class="fenxi-warp mt50">
                    <div class="fenxi-img">
                        <img :src="''+$parent.baseUrl+'/static/images/product1.jpg'" class="img db"/>
                        <div class="in">
                            <h1 class="color-white ac">舆论分析</h1>
                            <p class="mt20">7*24小时舆论分析人工服务，正确研判舆情，提供有效的工作决策和舆情预警做好舆情工作初期的信息初筛工作，定期为合作方输出日/周/月舆论分析报告。</p>
                            <router-link class="link db" :to="{path:''+$parent.baseUrl+'/yuYingGather'}"><button class="btn btn-jbblue db">开始使用</button></router-link>
                        </div>
                    </div>
                    <ul class="fenxi fr">
                        <li>
                            <img :src="''+$parent.baseUrl+'/static/images/fenxi1.png'" class="img fl"/>
                            <div class="text">
                                <h2>舆论推演</h2>
                                <p class="mt10 color-8a8a99">通过大数据和人工智能深度学习实现舆论事件发展、演变，以及未来走向的自动化预测、研判，帮助客户用大数据技术手段实时预判风险和机遇，为企业决策提供有力参考。</p>
                            </div>
                        </li>
                        <li>
                            <img :src="''+$parent.baseUrl+'/static/images/fenxi2.png'" class="img fl"/>
                            <div class="text">
                                <h2>数据溯源</h2>
                                <p class="mt10 color-8a8a99">当突发舆情事件时，清博智能可以回溯突发舆情事件相关数据信息，宏观分析整体舆情事件，预测舆情发展趋势，为进一步舆情应对提供决策参考。</p>
                            </div>
                        </li>
                        <li>
                            <img :src="''+$parent.baseUrl+'/static/images/fenxi3.png'" class="img fl"/>
                            <div class="text">
                                <h2>媒介关系图</h2>
                                <p class="mt10 color-8a8a99">对所有文章内容进行情感值判断，根据正面倾向占比来定义媒体与企业的关系，属于何种范围</p>
                            </div>
                        </li>
                        <li>
                            <img :src="''+$parent.baseUrl+'/static/images/fenxi4.png'" class="img fl"/>
                            <div class="text">
                                <h2>智库报告</h2>
                                <p class="mt10 color-8a8a99">以清博研究院为主体的智库研究团队，可根据客户个性化需求，采取不同合作方式，完成多领域、多样式的智库报告。</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="bg-white mt110">
            <div class="container clearfix">
                <div class="index-box clearfix">
                    <div class="index-title mt50 ac">
                        <h1>精耕细作，打造个性化行业解决方案</h1>
                        <p>丰富的数据类型，多维度数据服务，一站式为客户解决业务难题</p>
                    </div>
                    <div class="mt50 clearfix">
                        <ul class="plan-warp mt30 fl">
                            <li :class="currIndex === 0 ? 'curr' : ''" @click="planIndexTab(0);">
                                <p class="fs18">舆情分析</p>
                                <p class="color-8a8a99">自定义分析方案，境内外全网数据分析，多维度数据挖掘分析</p>
                            </li>
                            <li :class="currIndex === 1 ? 'curr' : ''" @click="planIndexTab(1);">
                                <p class="fs18">舆情预警</p>
                                <p class="color-8a8a99">灵活配置预警逻辑，支持短信、微信、邮件多重渠道预警方式</p>
                            </li>
                            <li :class="currIndex === 2 ? 'curr' : ''" @click="planIndexTab(2);">
                                <p class="fs18">传播分析</p>
                                <p class="color-8a8a99">不同维度对舆情分布、发展趋势、传播路径进行分析，直击舆情动态</p>
                            </li>
                            <li :class="currIndex === 3 ? 'curr' : ''" @click="planIndexTab(3);">
                                <p class="fs18">舆情报告</p>
                                <p class="color-8a8a99">基于数据分析，呈现多种样式，内容直观的专业舆情报告</p>
                            </li>
                            <li :class="currIndex === 4 ? 'curr' : ''" @click="planIndexTab(4);">
                                <p class="fs18">舆情大屏</p>
                                <p class="color-8a8a99">结合互联网与媒体数据，按需打造企业专属大数据可视化大屏</p>
                            </li>
                        </ul>
                        <div class="gif-box fr">
                            <img :src="indexGif[currIndex]" class="db"/>
                        </div>
                    </div>
                </div>
                <div class="index-box clearfix">
                    <div class="index-title mt50 ac">
                        <h1>广泛的应用场景</h1>
                        <p>完善的产品功能，洞悉各行业的需求痛点，提供广泛的应用场景</p>
                    </div>
                    <ul class="use mt50">
                        <li class="fenxi-img">
                            <img :src="''+$parent.baseUrl+'/static/images/use1.jpg'" class="img db"/>
                            <div class="in">
                                <h1 class="color-white ac">TO-企业</h1>
                                <p class="mt20">对海量网络舆论进行采集分析，并识别其中的关键舆情信息，及时通知到相关人员，对于企业关注的重点信息，及时通知到相关人员，实现第一时间应急响应，为企业形象舆论导向及收集网友意见提供一站式信息化平台，时刻关注企业的形象，洞察文化的系统概貌和整体水平，也可以评估企业在市场竞争中的真正实力。</p>
                            </div>
                        </li>
                        <li class="fenxi-img">
                            <img :src="''+$parent.baseUrl+'/static/images/use2.jpg'" class="img db"/>
                            <div class="in">
                                <h1 class="color-white ac">TO-政务</h1>
                                <p class="mt20">整合互联网数据，对互联网海量数据进行系统自动的收录、分类、聚焦，自动实时掌握互联网舆论，实现对民众的网络舆情分析，了解民众心声，并形成简报、日周月报，各项数据图表展示，全面的分析结果，保障网络舆论安全，广开言路，凝聚共识，提升服务效率和口碑。</p>
                            </div>
                        </li>
                        <li class="fenxi-img">
                            <img :src="''+$parent.baseUrl+'/static/images/use3.jpg'" class="img db"/>
                            <div class="in">
                                <h1 class="color-white ac">TO-媒体</h1>
                                <p class="mt20">全网数据24小时不间断分析，及时发现新闻热点，全面挖掘新闻线索，清晰梳理新闻传播脉络，跟踪受众喜好倾向，鉴别新闻真伪炒作；图文同步，为媒体提供便捷高效发稿分析。</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer clearfix">
            <div class="foot">
                <div class="nav fl">
                    <a target="_blank" href="http://home.nybkz.com/about-us.html">关于清博</a>
                    <a target="_blank" href="http://home.nybkz.com/news-report/">清博资讯</a>
                    <a target="_blank" href="http://home.nybkz.com/recruiting-talents.html">诚聘英才</a>
                    <a target="_blank" href="http://databus.nybkz.com/">开放平台</a>
                    <a target="_blank" href="http://www.nybkz.com/site/usage">榜单公式</a>
                    <a target="_blank" href="http://home.nybkz.com/cooperation.html">咨询&amp;合作</a>
                    <a target="_blank" href="http://home.nybkz.com/contact-us.html">联系我们</a>
                    <p>©2014-2017 北京清博智能科技有限公司 版权所有&nbsp;&nbsp;京ICP备16036802号-1&nbsp;&nbsp;<img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/beian.png" alt="公安局备案">
                        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802024017" rel="nofollow">
                            <span>京公网安备11010802024017号</span>
                        </a>
                    </p>
                </div>
                <div class="foot-imgs fr">
                    <a href=""><img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/ewm_qbzs.jpg"><span class="word">清博指数</span></a>
                    <a href=""><img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/ewm_qb.jpg"><span class="word">清博舆论</span></a>
                    <a href=""><img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/ewm_qbdsj.jpg"><span class="word">清博智能</span></a>
					<a href=""><img src="http://gsdata-img1.oss-cn-hangzhou.aliyuncs.com/gsdata/gsdata_doc/images/ewm_jlq.jpg"><span class="word">产品交流群</span></a>
                </div>
            </div>
        </div>
		<!-- 活动公告 -->
		<div class="modal" v-if="activityShow && activity != ''">
		    <div class="modal-bg"></div>
		    <div class="huodong">
		        <a class="close" @click="closeActivityAd" href="javascript:void(0);"><img src="http://yuqing.nybkz.com/vindex/resources/images/huodong_close.png"></a>
		        <a :href="activity.activityUrl" target="_blank"><img :src="activity.alertImg" class="img"></a>
		    </div>
		</div>
	</div>
</template>
<script>
export default {
    data() {
        return {
           indexGif:['https://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/images/gif1.gif','https://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/images/gif2.gif','https://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/images/gif3.gif','https://saas-pubsentiment-docs.oss-cn-hangzhou.aliyuncs.com/yq_report_new/images/gif4.gif',this.$parent.baseUrl+'/static/images/gif5.png'],
           currIndex:0,//解决方案当前图片
           move:'',
		   activityShow:false,
		   activity:[],
           indexEventType:[],
           indexEventList:[],//热点事件列表
           hotOneDayNewsList:[],//近24小时热点事件榜单
           currHotType:0,
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.indexHotEventType();
			that.getActivityAd();
        })
    },
    created() {

    },
    methods: {
        // 解决方案切换
        planIndexTab (index) {
            this.currIndex = index;
        },
        // 点击更多
        clickMore () {
            let move = this.move;
            if(move === 'down'){
                this.move = 'up';
            }else{
                this.move = 'down';
            }
        },
		// 获取活动
		getActivityAd (){
			let that = this;
			that.$api.get('home/index/index',null,r =>{
			    that.$parent.returnCode(r,function(){
			        let cooke = document.cookie.indexOf("activity_ad");//活动的cooke
					that.activity = r.data;
					if(cooke === -1){
						that.activityShow = true;
					}
			    })
			})
		},
		// 关闭活动
		closeActivityAd (){
			this.activityShow = false;
			let Days = 1;
			let exp = new Date();
			exp.setTime(exp.getTime() + Days*24*60*60*1000);
			document.cookie = 'activity_ad=' + escape(1) + ";expires=" + exp.toGMTString();
		},
        // 首页热点事件类型
        indexHotEventType () {
            let that = this;
            // that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('home/index/news-type',null,r =>{
                that.$parent.returnCode(r,function(){
                    // that.$parent.showLoad = false;
                    let province = '';
                    let data = r.data;
                    that.indexEventType = data;
                    that.clickHotEvent(0);
                    that.getHoursNews();
                })
            })
        },
        // 热点分类点击数据
        clickHotEvent (index) {//indexEventList
            let that = this;
            that.currHotType = index;
            let indexEventType = that.indexEventType;
            // that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('home/index/news-list	',{type:indexEventType[index].type,name:indexEventType[index].name},r =>{
                // that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    let data = r.data;
                    that.indexEventList = data;
                    // console.log(data);
                })
            })
        },
        // 近24小时热点事件榜单
        getHoursNews () {
            let that = this;
            // that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('home/index/hot-list', null, r =>{
                that.$parent.returnCode(r,function(){
                    // that.$parent.showLoad = false;
                    let data = r.data;
                    that.hotOneDayNewsList = data;
                })
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/index.vue